var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-custom"},[_c('Breadscrumbs',{attrs:{"links":[
      {
        name: 'Investor Relations',
        to: {
          name: 'IR'
        },
      },
       {
        name: 'Detail Page',
        to: {
          name: 'IRFinacialInformationDetailPage'
        },
      },
      {
        name: '編輯財務資訊',
        to: {
          name: 'EditFinancialInformation',
          params: {
            id: _vm.$route.params.id,
          },
          query: {
            section: _vm.$route.query.section,
          },
        },
      } ]}}),_c('div',{staticClass:"page-actions"},[_c('h2',[_vm._v("編輯財務資訊")]),_c('v-spacer'),_c('button',{staticClass:"btn mr-5",on:{"click":_vm.cancelHandler}},[_c('span',[_vm._v("取消")])]),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.saveHandler}},[_c('span',[_vm._v("儲存")])])],1),_c('FinancialInformationCreateEdit'),_c('LangDialog',{attrs:{"isOpen":_vm.isLangOpen},on:{"update:isOpen":function($event){_vm.isLangOpen=$event},"update:is-open":function($event){_vm.isLangOpen=$event},"confirm-submit":function($event){return _vm.saveHandler()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }